import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client'
import Header from './components/Header/Header';
import Banner from './components/Banner/Banner';
import Services from './components/Services/Services';
import Portfolio from './components/Portfolio/Portfolio';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import './scss/main.scss';

const rootElement = document.getElementById('root');

const app = (
  <React.StrictMode>
    <Header />
    <main>
      <Banner />
      <Services />
      <Portfolio />
      <Contact />
    </main>
    <Footer />
  </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}